export default __webpack_public_path__ + "static/media/adaptation.d4eab41e.svg";